<template>
	<div>
    <b-modal id="modal-data-loss-alert" ref="dataLossPopup" no-close-on-backdrop no-close-on-esc centered size="md" :header-bg-variant="'data-loss-popup-header'">
      <div slot="modal-header" class="header-section w-100">
        <div class="popup_head_txt">
          <span><strong>Are you sure you want to leave the page?</strong></span>
        </div>
        <div class="btn_container">
          <button class="btn_close" aria-label="close" @click="cancelLose">
            <span class="ic-close"></span>
          </button>
        </div>
      </div>
      <div class="text-center">
        <span>You will lose changes that were not saved.</span>
      </div>
      <div slot="modal-footer" class="w-100">
        <b-button @click="saveAndContinue" class="btn button-primary float-right mr-2">Save And Continue </b-button>        
        <b-button @click="okLose" class="btn button-primary float-right mr-2">Ok</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  export default {
    name: 'data-loss-prompt',
    created () {
      this.$parent.$on('resolveNext', this.resolveNext);
    },
    methods: {
      showPrompt () {
        this.$refs.dataLossPopup.show()
      },
      hidePrompt () {
        this.$refs.dataLossPopup.hide()
      },
      cancelLose () {
        this.hidePrompt()
      },
      okLose () {
        this.$emit('okLose')
        this.hidePrompt()
      },      
      saveAndContinue () {
        this.$emit('saveAndContinue')
        this.hidePrompt()
      },
      resolveNext (next) {
        next()
      }
    }

  }
</script>


<style>
  .popup_head_txt {
    font-size: 1.1rem;
    float: left;
    color: #323232;
  }

  .bg-data-loss-popup-header {
    background: #c0c0c0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/app/common/components/DataLossPrompt.vue